import z from 'zod';
import * as serializers from '@providers/LocalStorageState/serializers';

export const UserWorkflowSchema = z.any();

export default {
  deserialize: serializers.json.deserializeFactory(UserWorkflowSchema),
  serialize: serializers.json.serialize,
};
